import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useRef, useEffect, useState } from "react";
import { fetchHomePage } from "../../services/api";

export default function WhoWeAre({ lang = "en" }) {
  const [content, setContent] = useState(null);
  const [fallbackContent, setFallbackContent] = useState(null);

  const lottieFiles = [
    "/lottie-files/Strategic.lottie",
    "/lottie-files/Regional.lottie",
    "/lottie-files/Agile.lottie"
  ];

  // ✅ Top-level refs for Lottie components and their containers
  const itemRefs = useRef([]);
  const containerRefs = useRef([]);

  // Detect desktop vs mobile/tablet
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch data
  useEffect(() => {
  const loadData = async () => {
    try {
      const enData = await fetchHomePage("en");
      console.log("enData:", enData);
      
      if (enData) setFallbackContent(enData); // ✅ set fallback immediately

      if (lang !== "en") {
        const localData = await fetchHomePage(lang);
        console.log("localData:", localData);
        
        if (localData?.who_we_are_home?.length) {
          const merged = {
            ...enData,
            ...localData,
            who_we_are_home: localData.who_we_are_home.map((item, index) => {
              const enItem = enData?.who_we_are_home?.[index] || {};
              return {
                ...enItem,
                ...item,
                heading: item.heading || enItem.heading,
                text: item.text || enItem.text,
              };
            }),
          };
          setContent(merged);
        } else {
          setContent(enData);
        }
      } else {
        setContent(enData);
      }
    } catch (err) {
      console.error("Error:", err);
      // ✅ if everything fails still stop loading
      setContent({});
    }
  };

  loadData();
}, [lang]);

  const data = content ?? fallbackContent;

  // ✅ IntersectionObserver for autoplay on mobile/tablet
  useEffect(() => {
    if (isDesktop || !data) return;

    const observers = containerRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              itemRefs.current[index]?.play();
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [isDesktop, data]);

  if (!data) return <p className="p-6">Loading...</p>;

  return (
    <div className="padding-x-40 padding-y-80">
      {/* Section Title */}
      <div className="section-name-wrapper">
        <div className="section-name-dot"></div>
        <span className="section-name">{data.who_we_are_section_name}</span>
      </div>

      {/* Section Description */}
      
      <h2   dangerouslySetInnerHTML={{ __html: data.who_we_are_title }} className="size-h3 mb-160 pt-2.5 text-dark-blue-color w-[100%] md:w-[70%]">
        
      </h2>

      {/* Cards */}
     <div className="custom-lg-flex  items-stretch justify-between">
  {data?.who_we_are_home?.map((item, index) => (
    <div
      key={item.id}
      className="w-full md:w-[48%] xl:w-[32%] flex items-end justify-center  "
      onMouseEnter={() => isDesktop && itemRefs.current[index]?.play()}
      onMouseLeave={() => isDesktop && itemRefs.current[index]?.stop()}
    >
      <div className="border-t w-full h-full flex justify-between py-5 xl:pb-0 items-end" style={{borderColor: "rgba(25, 175, 225, 1)"}}>
        <div className="col-9 padding-right-40 h-full who-we-are-mobile-space" >
          <h3 className="size-h5 text-dark-blue-color " style={{marginBottom: "8px"}}>{item.heading}</h3>
          <p className="font-medium text-dark-blue-color">{item.text}</p>
        </div>

        <div
          ref={(el) => (containerRefs.current[index] = el)}
          className="col-3 lottie-radius overflow-hidden"
          style={{ width: "100px", height: "100px", borderRadius: "5px" }}
        >
          <DotLottieReact
            src={lottieFiles[index]}
            loop
            autoplay={false}
            dotLottieRefCallback={(ref) => (itemRefs.current[index] = ref)}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>
    </div>
  ))}
</div>
    </div>
  );
}